/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { colors } from "./colors";
import { Tabs } from "antd";
import type { TabsProps } from "antd";

type Props = {
  leftTabIndent?: string;
} & TabsProps;

export const TabsComponent = ({
  items,
  defaultActiveKey,
  leftTabIndent,
  ...rest
}: Props) => {
  const containerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1200px;

    > .ant-tabs-top > .ant-tabs-nav::before {
      border-bottom: 0px;
    }

    > .ant-tabs-top > .ant-tabs-nav > .ant-tabs-nav-wrap {
      overflow: visible;
      > .ant-tabs-nav-list {
        gap: 16px;
        ${leftTabIndent && `margin-left: ${leftTabIndent};`}
        > .ant-tabs-ink-bar {
          display: none;
        }
        > .ant-tabs-tab {
          color: ${colors.textSecondary};
          font-family: Inter;
          margin: 0px;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          padding: 0px;
          &:hover {
            color: ${colors.textPrimary} !important;
          }
          > .ant-tabs-tab-btn {
            padding: 8px 16px;
          }
        }
        > .ant-tabs-tab-active > .ant-tabs-tab-btn {
          color: ${colors.textPrimary};
          box-shadow: 0px 0px 0px 1px ${colors.greyBorder},
            0px 1px 1px 0px rgba(0, 0, 0, 0.1);
          border-radius: 9999px;
          font-weight: 600;
          background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.04) 100%
            ),
            ${colors.white};
        }
        > .ant-tabs-ink-bar {
          background: ${colors.textPrimary} !important;
        }
      }
    }
  `;

  return (
    <div css={containerStyle}>
      <Tabs defaultActiveKey={defaultActiveKey} items={items} {...rest} />
    </div>
  );
};
